module.exports = __webpack_public_path__ + "static/media/kleiner.fda1c785.svg";